<template>
  <div>
    <div class="container-fluid">
      <!-- <pre>{{debtor.customer}}</pre> -->
      <div class="row">
        <div class="col-xl-3 col-lg-4">
          <aside class="profile-side profile-side-sm">
            <section
              class="box-typical profile-side-user-sm- box-card-header-sm text-left bg-white"
            >
              <b-row>
                <div class="col-sm-9"></div>
                <div class="col-sm-3 text-right">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="mr-1"
                    title="Editar"
                    @click="editDebtor()"
                    :disabled="status_debt || !EDITAR_DEUDOR"
                  >
                    <i class="fa fa-edit"></i>
                  </b-button>
                </div>
              </b-row>
              <b-row>
                <div class="col-sm-12 text-center">
                  <p class="font-size-14 mb-0" v-if="debtor.business_name">
                    <strong>{{ debtor.business_name }}</strong>
                  </p>
                  <p class="font-size-12 mt-0">
                    CC/NIT {{ debtor.identification }}
                    <span v-if="debtor.check_digit != null"
                      >- {{ debtor.check_digit }}</span
                    >
                  </p>
                </div>
              </b-row>
              <b-row class="mt-2 ml-1 mr-1 mb-2">
                <b-col class="pr-1">
                  <b-form-select
                    v-model="debtor.process_id"
                    class="custom-select-trebol-primary"
                    :disabled="true"
                    @change="changeProcess()"
                  >
                    <option
                      v-for="item in lstProcess"
                      :key="item.id"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-col>
                <b-col class="pl-0">
                  <b-form-select
                    v-model="debtor.type"
                    class="custom-select-trebol-danger"
                    :disabled="
                      status_debt || role_id == 6 || !EDITAR_TIPIFICACION
                    "
                    @change="changeType()"
                  >
                    <option
                      v-for="item in lstType"
                      :key="item.id"
                      :value="item.id"
                      :disabled="item.disabled"
                    >
                      {{ item.name }}
                    </option>
                  </b-form-select>
                </b-col>
              </b-row>

              <b-row
                class="mt-2 ml-1 mr-3 mb-2"
                v-if="this.debtor.process_id != 1"
              >
                <b-col class="pr-1">
                  <b-form-select
                    v-model="debtor.probability"
                    class="custom-select-trebol-info"
                    :disabled="status_debt || role_id == 6"
                    @change="changeProbability()"
                  >
                    <option value="A">Alta</option>
                    <option value="M">Media</option>
                    <option value="B">Baja</option>
                  </b-form-select>
                </b-col>
              </b-row>
            </section>

            <!-- INICIO ALERTA DE MONTOS MÍNIMOS -->
            <b-row
              class="p-0"
              v-if="is_smaller_amount != null && is_smaller_amount == true"
            >
              <div class="col-12">
                <div class="card mb-1 mt-0">
                  <div class="card-body p-0 d-flex align-items-center">
                    <i class="fa fa-bell bg-danger p-4 font-2xl mr-3"></i>
                    <div>
                      <div class="text-value-sm text-danger">
                        Montos mínimos.
                      </div>
                      <div class="text-muted small text-justify mr-1">
                        Su cartera no alcanza el mínimo requerido.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>
            <!-- FIN ALERTA DE MONTOS MÍNIMOS -->

            <!-- INICIO ALERTA DE CARTERA PRESCRITA -->
            <b-row class="p-0" v-if="pre_written">
              <div class="col-12">
                <div class="card mb-3">
                  <div class="card-body p-0 d-flex align-items-center">
                    <i class="fa fa-bell bg-danger p-4 font-2xl mr-3"></i>
                    <div>
                      <div class="text-value-sm text-danger">
                        Cartera prescrita.
                      </div>
                      <div class="text-muted small text-justify mr-1">
                        Facturas prescritas: {{ pre_written }}.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-row>
            <!-- FIN ALERTA DE CARTERA PRESCRITA -->

            <section class="box-typical bg-white">
              <header class="widget-header-dark m-0 p-1">
                Detalle de la deuda
              </header>
              <div class="box-typical-inner">
                <table class="table table-striped ml-0 pl-0">
                  <tbody>
                    <tr v-if="role_id != 6">
                      <th scope="row">Tipo</th>
                      <td class="text-right al-vm">
                        {{ settlement.wallet_type_name }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Facturas</th>
                      <td class="text-right al-vm">
                        {{ settlement.invoice_count }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Capital inicial</th>
                      <td class="text-right al-vm">
                        $ {{ formatPrice(settlement.capital) }}
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">Abonos previos al cliente</th>
                      <td class="text-right al-vm">
                        $ {{ formatPrice(settlement.initial_payments) }}
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">Capital recibido por Trébol</th>
                      <td class="text-right al-vm">
                        $
                        {{
                          formatPrice(
                            settlement.capital - settlement.initial_payments
                          )
                        }}
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">Abonos al capital</th>
                      <td class="text-right al-vm">
                        $ {{ formatPrice(settlement.capital_recovered) }}
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">Capital por cobrar</th>
                      <td class="text-right al-vm">
                        $
                        {{
                          formatPrice(
                            settlement.capital -
                              settlement.initial_payments -
                              settlement.capital_recovered
                          )
                        }}
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">Total intereses</th>
                      <td class="text-right al-vm">
                        $ {{ formatPrice(settlement.interest) }}
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">Abonos a intereses</th>
                      <td class="text-right al-vm">
                        $ {{ formatPrice(settlement.interests_recovered) }}
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Intereses por cobrar</th>
                      <td class="text-right al-vm">
                        $
                        {{
                          formatPrice(
                            settlement.interest - settlement.interests_recovered
                          )
                        }}
                      </td>
                    </tr>

                    <tr v-if="role_id != 6">
                      <th scope="row">Total honorarios</th>
                      <td class="text-right al-vm">
                        $ {{ formatPrice(settlement.fee) }}
                      </td>
                    </tr>

                    <tr v-if="role_id != 6">
                      <th scope="row">Honorarios cobrados</th>
                      <td class="text-right al-vm">
                        $ {{ formatPrice(settlement.fees_recovered) }}
                      </td>
                    </tr>

                    <tr v-if="role_id != 6">
                      <th scope="row">Honorarios por cobrar</th>
                      <td class="text-right al-vm">
                        $
                        {{
                          formatPrice(
                            settlement.fee - settlement.fees_recovered
                          )
                        }}
                      </td>
                    </tr>

                    <tr>
                      <th scope="row">Total recuperado</th>
                      <td class="text-right al-vm">
                        $
                        {{
                          formatPrice(
                            settlement.capital_recovered +
                              settlement.interests_recovered +
                              settlement.fees_recovered
                          )
                        }}
                      </td>
                    </tr>
                    <!-- <tr>
                            <th scope="row">Descuento</th>
                            <td class="text-right al-vm">{{settlement.discount}}%</td>
                    </tr>-->
                    <tr class="custom-select-trebol-primary">
                      <th scope="row">Total por cobrar</th>
                      <td class="text-right al-vm">
                        $
                        {{
                          formatPrice(
                            settlement.capital -
                              settlement.initial_payments +
                              settlement.interest +
                              settlement.fee -
                              (settlement.capital_recovered +
                                settlement.interests_recovered +
                                settlement.fees_recovered)
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <b-row>
                  <b-col sm="8">
                    <strong class="text-danger">CERRAR DEUDA</strong>
                  </b-col>
                  <b-col sm="4 text-right">
                    <c-switch
                      v-model="status_debt"
                      class="ml-2 mb-2"
                      color="primary"
                      label
                      variant="pill"
                      v-bind="labelTxt"
                      :disabled="!CERRAR_DEUDA"
                      :size="'sm'"
                      @change="actionDebt()"
                    />
                  </b-col>
                </b-row>
              </div>
            </section>
          </aside>
        </div>

        <div class="col-xl-9 col-lg-8">
          <!-- INICIO TABS DE PRUEBA -->

          <div class="row mt-4 tbs-customer">
            <b-tabs
              justified
              class="w100 custom-tabs"
              active-nav-item-class="font-weight-bold text-success"
            >
              <b-tab title="Detalle" active>
                <section class="mr-5 ml-5 mt-2">
                  <div class="box-typical-inner">
                    <!-- <pre>{{debtor.customer}}</pre> -->
                    <h5 class="mb-0">
                      <strong>DETALLES DEL DEUDOR</strong>
                    </h5>

                    <hr class="mt-2 mb-3" />
                    <div class="row">
                      <div class="col-sm-6">
                        <p
                          class="font-size-13 mb-0"
                          v-if="debtor.business_name"
                        >
                          <strong>Cuenta:</strong>
                          {{ debtor.customer.identification }} -
                          {{ debtor.customer.business_name }}
                        </p>
                        <p class="font-size-13 mb-0">
                          <strong>Estado:</strong>
                          {{ debtor.status_name }}
                        </p>
                        <p class="font-size-13 mb-0">
                          <strong>Contrato:</strong>
                          {{ debtor.agreement_number }}
                        </p>
                        <p class="font-size-13 mb-0">
                          <strong>Orden de servicio:</strong>
                          {{ debtor.service_order_number }}
                        </p>
                        <p class="font-size-13 mb-0">
                          <strong>
                            <span v-if="debtor.process_id == 1">Cobrador:</span>
                            <span v-else>Abogado:</span>
                          </strong>
                          {{ debtor.staff_name }}
                        </p>

                        <p class="font-size-13 mb-0">
                          <strong>Comercial:</strong>
                          {{ debtor.customer_staff_name }}
                        </p>

                        <p class="font-size-13 mb-0">
                          <strong>Ingreso a etapa Prejurídica:</strong>
                          {{ formatDateDescription(debtor.date_prejury) }}
                        </p>

                        <p class="font-size-13 mb-0">
                          <strong>Ingreso a etapa Jurídica:</strong>
                          {{ formatDateDescription(debtor.date_jury) }}
                        </p>

                        <p class="font-size-13 mb-0" v-if="status_debt">
                          <strong>Fecha cierre deuda:</strong>
                          {{ formatDateDescription(settlement.date) }}
                        </p>

                        <!-- <p class="font-size-13 mb-0"><strong>Abogado: </strong> {{debtor.staff_name}}</p>             -->
                      </div>

                      <!-- <div class="col-sm-6">
                                    <p class="font-size-13 mb-0"><strong>Atendido por: </strong> {{debtor.customer.staff_name}}</p>
                                    <p class="font-size-13 mb-0"><strong>Industria: </strong> {{debtor.customer.industries_name}}</p>
                                    <p class="font-size-13 mb-0 text-justify"><strong>Sub Industria: </strong> {{debtor.customer.sub_industries_name}}</p>
                      </div>-->
                    </div>

                    <div v-if="visible(debtor.lstCustomFieldsData)">
                      <p class="mb-1 mt-3">
                        <strong>CAMPOS PERSONALIZADOS</strong>
                      </p>
                      <hr class="mb-3 mt-0" />
                      <div
                        v-for="fData in debtor.lstCustomFieldsData"
                        :key="fData.custom_field_id"
                        :value="fData.custom_field_id"
                      >
                        <p class="line-with-icon">
                          <strong>{{ fData.name }}:</strong>
                          {{ fData.value }}
                        </p>
                      </div>
                    </div>

                    <div v-if="visible(debtor.lstAddress)">
                      <p class="mb-1 mt-3">
                        <strong>DIRECCIONES</strong>
                      </p>
                      <hr class="mb-3 mt-0" />

                      <div
                        v-for="(item, index) in debtor.lstAddress"
                        :key="index"
                        :value="item.id"
                      >
                        <p class="font-size-14 mb-1">
                          <strong>Dirección {{ index + 1 }}</strong>
                        </p>

                        <div class="row">
                          <div
                            class="col-sm-6"
                            v-if="
                              visible(item.lstMobile) ||
                              visible(item.lstMobileN) ||
                              visible(item.lstPhone) ||
                              visible(item.lstPhoneN) ||
                              visible(item.lstMail)
                            "
                          >
                            <div
                              v-for="(itemMobile, i) in item.lstMobile"
                              :key="itemMobile.key"
                              :value="itemMobile.key"
                            >
                              <p class="font-size-13 mb-0 text-success">
                                <strong>Celular positivo {{ i + 1 }}:</strong>
                                {{ itemMobile.value }}
                              </p>
                            </div>

                            <div
                              v-for="(itemMobile, l) in item.lstMobileN"
                              :key="itemMobile.key"
                              :value="itemMobile.key"
                            >
                              <p class="font-size-13 mb-0 text-danger">
                                <strong>Celular negativo {{ l + 1 }}:</strong>
                                {{ itemMobile.value }}
                              </p>
                            </div>

                            <div
                              v-for="(itemPhone, j) in item.lstPhone"
                              :key="itemPhone.value"
                              :value="itemPhone.key"
                            >
                              <p class="font-size-13 mb-0 text-success">
                                <strong>Teléfono positivo {{ j + 1 }}:</strong>
                                {{ itemPhone.value }}
                              </p>
                            </div>

                            <div
                              v-for="(itemPhone, m) in item.lstPhoneN"
                              :key="itemPhone.value"
                              :value="itemPhone.key"
                            >
                              <p class="font-size-13 mb-0 text-danger">
                                <strong>Teléfono negativo {{ m + 1 }}:</strong>
                                {{ itemPhone.value }}
                              </p>
                            </div>

                            <div
                              v-for="(itemMail, k) in item.lstMail"
                              :key="itemMail.value"
                              :value="itemMail.key"
                            >
                              <p class="font-size-13 mb-0">
                                <strong>Correo electrónico {{ k + 1 }}:</strong>
                                <a href="javascript:void(0);">{{
                                  itemMail.value
                                }}</a>
                              </p>
                            </div>
                          </div>

                          <div class="col-sm-6">
                            <p class="font-size-13 mb-0">
                              <strong>Dirección:</strong>
                              {{ item.address }}
                            </p>
                            <p class="font-size-13 mb-0">
                              <strong>Barrio:</strong>
                              {{ item.neighborhood }}
                            </p>
                            <p class="font-size-13 mb-0">
                              <strong>Departamento:</strong>
                              {{ item.zone_name }}
                            </p>
                            <p class="font-size-13 mb-0">
                              <strong>Ciudad:</strong>
                              {{ item.city_name }}
                            </p>
                            <p class="font-size-13 mb-0">
                              <strong>País:</strong>
                              {{ item.country_name }}
                            </p>
                          </div>
                        </div>

                        <hr class="mt-2 mb-3" v-if="index > 0" />
                      </div>
                    </div>

                    <div v-if="visible(debtor.lstContacto)">
                      <p class="mb-1 mt-3">
                        <strong>REFERENCIAS DE CONTACTO</strong>
                      </p>
                      <hr class="mb-3 mt-0" />

                      <div
                        v-for="item in debtor.lstContacto"
                        :key="item.id"
                        :value="item.id"
                      >
                        <p class="line-with-icon" v-if="item.name">
                          <strong>Nombre:</strong>
                          {{ item.name }} {{ item.last_name }}
                        </p>

                        <p class="line-with-icon" v-if="item.occupation">
                          <strong>Cargo:</strong>
                          {{ item.occupation }}
                        </p>

                        <p class="line-with-icon" v-if="item.mail">
                          <strong>Correo:</strong>
                          <a href="#">{{ item.mail }}</a>
                        </p>

                        <p class="line-with-icon" v-if="item.phone_number">
                          <strong>Teléfono:</strong>
                          +{{ item.phone_zone }} {{ item.phone_area }}
                          {{ item.phone_number }}
                        </p>

                        <p class="line-with-icon" v-if="item.mobile_number">
                          <strong>Celular:</strong>
                          +{{ item.mobile_zone }} {{ item.mobile_area }}
                          {{ item.mobile_number }}
                        </p>

                        <p class="line-with-icon" v-if="item.birthday_date">
                          <strong>Cumpleaños:</strong>
                          {{ item.birthday_date }}
                        </p>

                        <hr class="mt-2 mb-3" />
                      </div>
                    </div>

                    <p class="mb-1 mt-3" v-if="debtor.observation">
                      <strong>COMENTARIOS</strong>
                    </p>
                    <hr class="mb-3 mt-0" v-if="debtor.observation" />

                    <p class="font-size-13 text-justify">
                      {{ debtor.observation }}
                    </p>
                  </div>
                </section>
              </b-tab>

              <b-tab title="Gestiones">
                <p class="mb-1">
                  <strong>GESTIONES DE COBRO</strong>
                </p>
                <hr class="p-0 mt-0" />

                <form class="box-typical" v-if="CREAR_GESTIONES">
                  <textarea
                    type="text"
                    class="write-something"
                    rows="3"
                    :placeholder="`- Ingresa tu gestión`"
                    v-model="task_management.management"
                  ></textarea>

                  <div class="box-typical-footer">
                    <div class="tbl">
                      <div class="tbl-row">
                        <b-row>
                          <b-col sm="3" class="pr-0">
                            <b-form-group>
                              <date-picker
                                name="date"
                                v-model="task_management.date"
                                :config="options"
                                placeholder="Fecha"
                                @dp-change="
                                  validarTiempoDiarioGestiones(task_management)
                                "
                              ></date-picker>
                            </b-form-group>
                          </b-col>

                          <b-col sm="2" class="pr-0">
                            <b-form-group>
                              <b-form-select v-model="task_management.type">
                                <template slot="first">
                                  <option :value="null" disabled>
                                    -- Tipo Gestión --
                                  </option>
                                </template>

                                <option
                                  v-for="item in lstTypeTaskManagement"
                                  :key="item.id"
                                  :value="item.id"
                                >
                                  {{ item.name }}
                                </option>
                              </b-form-select>
                            </b-form-group>
                          </b-col>

                          <b-col sm="2" class="pr-0">
                            <b-form-group>
                              <b-form-select
                                v-model="task_management.minutes"
                                @change="
                                  validarTiempoDiarioGestiones(task_management)
                                "
                              >
                                <template slot="first">
                                  <option :value="null" disabled>
                                    -- Tiempo --
                                  </option>
                                </template>
                                <option value="5">5 min</option>
                                <option value="10">10 min</option>
                                <option value="15">15 min</option>
                                <option value="30">30 min</option>
                                <option value="45">45 min</option>
                                <option value="60">60 min (1 h)</option>
                                <option value="90">90 min (1.5 h)</option>
                                <option value="120">120 min (2 h)</option>
                                <option value="150">150 min (2.5 h)</option>
                                <option value="180">180 min (3 h)</option>
                                <option value="240">240 min (4 h)</option>
                                <option value="300">300 min (5 h)</option>
                                <option value="360">360 min (6 h)</option>
                                <option value="420">420 min (7 h)</option>
                                <option value="480">480 min (8 h)</option>
                              </b-form-select>
                            </b-form-group>
                          </b-col>

                          <b-col sm="2">
                            <b-form-group>
                              <b-form-select v-model="task_management.privacy">
                                <!-- <template slot="first">
                                  <option :value="null" disabled>-- Privacidad --</option>
                                </template>-->
                                <option
                                  v-for="item in lstPrivacy"
                                  :key="item.id"
                                  :value="item.id"
                                >
                                  {{ item.name }}
                                </option>
                              </b-form-select>
                            </b-form-group>
                          </b-col>

                          <b-col class="pr-0 pl-0">
                            <b-form-group>
                              <b-form-file
                                :browse-text="'Busc...'"
                                v-model="file"
                                v-on:change="onFileChange"
                                placeholder="Doc ..."
                                drop-placeholder="Doc ..."
                              ></b-form-file>
                            </b-form-group>
                          </b-col>

                          <b-col sm="1">
                            <b-form-group>
                              <button
                                type="button"
                                class="btn btn-success"
                                @click="saveTaskManagement()"
                              >
                                Enviar
                              </button>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </form>

                <div
                  class="without"
                  v-if="!lstTaskManagements || lstTaskManagements.length == 0"
                  style="margin-top: 0px"
                >
                  <div class="row">
                    <figure class="text-center">
                      <img src="img/sin_gestion.png" alt width="210px" />
                    </figure>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-center">
                      <h1>Oops!</h1>
                      <h4>
                        Parece que no hay
                        <br />gestiones en esta cuenta.
                      </h4>
                    </div>
                  </div>
                </div>

                <div class="comments" v-else>
                  <strong>
                    <p>Historial de gestiones</p>
                  </strong>
                  <section
                    class="box-typical comment box-typical-custom"
                    v-for="item in lstTaskManagements"
                    :key="item.id"
                  >
                    <div class="row">
                      <div class="col-sm-2 mr-0">
                        <div class="row">
                          <div class="col-md-12 text-center">
                            <strong>
                              <p>CREADA POR</p>
                            </strong>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12 text-center">
                            <img
                              v-if="item.user_image === null"
                              src="img/avatars/avatar-2-64.png"
                              class="rounded-circle"
                            />
                            <img
                              v-else
                              :src="item.user_image"
                              class="rounded-circle img-gestion"
                            />
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12 text-center">
                            <p class="mt-2">{{ item.user_name }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-10">
                        <div class="row">
                          <div class="col-sm-9">
                            <strong>
                              <p>COMENTARIO</p>
                            </strong>
                          </div>
                          <div class="col-sm-3 text-right pr-0">
                            <b-button
                              size="sm"
                              variant="info"
                              class="mr-1"
                              title="Editar"
                              @click="editTaskManagement(item)"
                              v-if="EDITAR_GESTIONES"
                            >
                              <i class="fa fa-edit"></i>
                            </b-button>

                            <b-button
                              size="sm"
                              class="mr-1"
                              variant="danger"
                              title="Eliminar"
                              @click="deleteTaskManagement(item)"
                              v-if="ELIMINAR_GESTIONES"
                            >
                              <i class="fa fa-trash"></i>
                            </b-button>

                            <b-button
                              size="sm"
                              variant="warning"
                              title="Descargar documento"
                              @click="dowloadDocument(item.document)"
                              v-if="item.document"
                            >
                              <i class="fa fa-download"></i>
                            </b-button>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12 text-justify">
                            <p>{{ item.management }}</p>
                          </div>
                        </div>
                        <hr />

                        <div class="row row-footer">
                          <div class="col">
                            <p>
                              <strong>FECHA</strong>
                            </p>
                            <p>
                              {{
                                role_id == 6 ? item.date_customer : item.date
                              }}
                            </p>
                          </div>

                          <div class="col" v-if="role_id != 6">
                            <p>
                              <strong>TIPO DE GESTIÓN</strong>
                            </p>
                            <p>{{ item.type_name }}</p>
                          </div>

                          <div class="col" v-if="role_id != 6">
                            <p>
                              <strong>TIEMPO</strong>
                            </p>
                            <p>{{ item.minutes }} min</p>
                          </div>

                          <div class="col" v-if="role_id != 6">
                            <p>
                              <strong>PRIVACIDAD</strong>
                            </p>
                            <p>{{ item.privacy_name }}</p>
                          </div>
                        </div>
                        <div class="row row-footer" v-if="role_id != 6">
                          <div class="w100 text-right mr-2">
                            <p>
                              <i class="fa fa-clock-o"></i>
                              &nbsp;{{ item.created_at }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <nav
                    v-if="paginationGestion.last_page > 1"
                    aria-label="Page navigation example"
                  >
                    <ul class="pagination justify-content-end pagination-sm">
                      <li
                        v-if="paginationGestion.current_page == 1"
                        class="page-item disabled"
                      >
                        <a class="page-link" tabindex="-1">Anterior</a>
                      </li>

                      <li v-else class="page-item">
                        <a
                          class="page-link"
                          tabindex="-1"
                          @click="
                            getTaskManagement(paginationGestion.prev_page_url)
                          "
                          >Anterior</a
                        >
                      </li>

                      <div
                        v-for="page in paginationGestion.last_page"
                        :key="page"
                        :value="page"
                      >
                        <li
                          v-if="paginationGestion.current_page == page"
                          class="page-item active"
                        >
                          <a class="page-link">{{ page }}</a>
                        </li>
                        <li v-else class="page-item">
                          <a
                            class="page-link"
                            @click="
                              getTaskManagement(
                                paginationGestion.path + '?page=' + page
                              )
                            "
                            >{{ page }}</a
                          >
                        </li>
                      </div>
                      <li
                        v-if="
                          paginationGestion.current_page ==
                          paginationGestion.last_page
                        "
                        class="page-item disabled"
                      >
                        <a class="page-link">Siguiente</a>
                      </li>
                      <li v-else class="page-item">
                        <a
                          class="page-link"
                          @click="
                            getTaskManagement(paginationGestion.next_page_url)
                          "
                          >Siguiente</a
                        >
                      </li>
                    </ul>
                  </nav>
                </div>
              </b-tab>

              <b-tab title="Actividades" v-if="this.debtor.process_id != 1 && (role_id == 1 || role_id == 5 || role_id == 9 || role_id == 2 || role_id == 7)">
                <task-jury-component
                  v-if="debtor.id"
                  :debtor_id="this.$route.params.id"
                />
              </b-tab>

              <b-tab title="Jurídico" v-if="this.debtor.process_id != 1 && (role_id == 1 || role_id == 5 || role_id == 6 || role_id == 9 || role_id == 2 || role_id == 7)">
                <legal-component
                  v-if="debtor.id"
                  :debtor_id="this.$route.params.id"
                  :customer_name="debtor.customer.business_name"
                  :total_debt="
                    formatPrice(
                      settlement.capital -
                        settlement.initial_payments +
                        settlement.interest +
                        settlement.fee -
                        (settlement.capital_recovered +
                          settlement.interests_recovered +
                          settlement.fees_recovered)
                    )
                  "
                />
              </b-tab>

              <b-tab title="Est. Bienes" v-if="(role_id == 1 || role_id == 5 || role_id == 6 || role_id == 9 || role_id == 2 || role_id == 7|| role_id == 4 || role_id == 8)">
                <study-good-component
                  v-if="debtor.id"
                  :debtor_id="this.$route.params.id"
                />
              </b-tab>

              <b-tab title="Resumen" v-if="this.debtor.process_id != 1 && (role_id == 1 || role_id == 5 || role_id == 6 || role_id == 9 || role_id == 2 || role_id == 7)">
                <summary-component
                  v-if="debtor.id"
                  :debtor_id="this.$route.params.id"
                  :customer_name="debtor.customer.business_name"
                  :total_debt="
                    formatPrice(
                      settlement.capital -
                        settlement.initial_payments +
                        settlement.interest +
                        settlement.fee -
                        (settlement.capital_recovered +
                          settlement.interests_recovered +
                          settlement.fees_recovered)
                    )
                  "
                  :probability ="debtor.probability"
                />
              </b-tab>

              <b-tab title="Med. Cautelares" v-if="this.debtor.process_id != 1 && (role_id == 1 || role_id == 5 || role_id == 6 || role_id == 9 || role_id == 2 || role_id == 7)">
                <caution-component
                  v-if="debtor.id"
                  :debtor_id="this.$route.params.id"
                />
              </b-tab>

              <b-tab title="Facturas">
                <invoice-component
                  v-if="debtor.id && currency && currency.id"
                  :_debtor_id="this.$route.params.id"
                  :_closed_debt="this.status_debt"
                  :_currency="this.currency"
                />
              </b-tab>

              <b-tab title="Abonos">
                <payment-component
                  v-if="debtor.id && currency && currency.id"
                  :_debtor_id="this.$route.params.id"
                  :_closed_debt="this.status_debt"
                  :debtor_status="this.debtor.status"
                  :_currency="this.currency"
                />
              </b-tab>

              <b-tab title="Adjuntos">
                <document-component
                  v-if="debtor.id"
                  :_table="table"
                  :_table_id="this.$route.params.id"
                  :_settlement="this.settlement"
                />
              </b-tab>

              <!-- <b-tab title="CARTAS">CARTAS</b-tab> -->

              <!-- <b-tab title="JURÍDICO">
                  JURÍDICO
              </b-tab>
              <b-tab title="RECORDATORIOS">
                  RECORDATORIOS
              </b-tab>-->
            </b-tabs>
          </div>

          <!-- FIN TABS DE PRUEBA -->
          <!-- FIN GESTIÓN DEUDOR-->
        </div>
      </div>
    </div>

    <!-- MODAL PARA LAS GESTIONES -->
    <div class="modal fade" id="dlgTaskManagement">
      <div class="modal-dialog modal-dialog-centered modal-success modal-lg">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">GESTIÓN</h4>
            <button type="button" class="close" @click="closeTaskManagement()">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form
              @submit.prevent="updateTaskManagement()"
              method="put"
              class="box-typical"
              v-if="task_management_edit.id"
            >
              <textarea
                type="text"
                class="write-something"
                rows="3"
                :placeholder="`- Ingresa tu gestión`"
                v-model="task_management_edit.management"
              ></textarea>

              <div class="box-typical-footer">
                <div class="tbl">
                  <div class="tbl-row">
                    <b-row>
                      <b-col sm="3" class="pr-0">
                        <b-form-group>
                          <date-picker
                            id="txtFecha"
                            name="date"
                            v-model="task_management_edit.date"
                            :config="options"
                            placeholder="Fecha"
                            @dp-change="
                              validarTiempoDiarioGestiones(task_management_edit)
                            "
                          ></date-picker>
                        </b-form-group>
                      </b-col>

                      <b-col sm="2" class="pr-0">
                        <b-form-group>
                          <b-form-select v-model="task_management_edit.type">
                            <template slot="first">
                              <option :value="null" disabled>
                                -- Tipo Gestión --
                              </option>
                            </template>

                            <option
                              v-for="item in lstTypeTaskManagement"
                              :key="item.id"
                              :value="item.id"
                            >
                              {{ item.name }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col sm="2" class="pr-0">
                        <b-form-group>
                          <b-form-select
                            v-model="task_management_edit.minutes"
                            @change="
                              validarTiempoDiarioGestiones(task_management_edit)
                            "
                          >
                            <template slot="first">
                              <option :value="null" disabled>
                                -- Tiempo --
                              </option>
                            </template>
                            <option value="5">5 min</option>
                            <option value="10">10 min</option>
                            <option value="15">15 min</option>
                            <option value="30">30 min</option>
                            <option value="45">45 min</option>
                            <option value="60">60 min (1 h)</option>
                            <option value="90">90 min (1.5 h)</option>
                            <option value="120">120 min (2 h)</option>
                            <option value="150">150 min (2.5 h)</option>
                            <option value="180">180 min (3 h)</option>
                            <option value="240">240 min (4 h)</option>
                            <option value="300">300 min (5 h)</option>
                            <option value="360">360 min (6 h)</option>
                            <option value="420">420 min (7 h)</option>
                            <option value="480">480 min (8 h)</option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col sm="2">
                        <b-form-group>
                          <b-form-select v-model="task_management_edit.privacy">
                            <template slot="first">
                              <option :value="null" disabled>
                                -- Privacidad --
                              </option>
                            </template>

                            <option
                              v-for="item in lstPrivacy"
                              :key="item.id"
                              :value="item.id"
                            >
                              {{ item.name }}
                            </option>
                          </b-form-select>
                        </b-form-group>
                      </b-col>

                      <b-col class="pr-0 pl-0">
                        <b-form-group>
                          <b-form-file
                            :browse-text="'Busc...'"
                            v-model="file"
                            v-on:change="onFileChange"
                            placeholder="Doc ..."
                            drop-placeholder="Doc ..."
                          ></b-form-file>
                        </b-form-group>
                      </b-col>

                      <b-col sm="1">
                        <b-form-group>
                          <button type="submit" class="btn btn-success">
                            Enviar
                          </button>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </div>
            </form>
            <!--.box-typical-->
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LAS GESTIONES -->
  </div>
</template>

<script>
import PaymentComponent from "@/components/Payment.vue";
import InvoiceComponent from "@/components/Invoice";
import DocumentComponent from "@/components/Document";
import LegalComponent from "@/components/Legal.vue";
import TaskJuryComponent from "@/components/TaskJury.vue";
import StudyGoodComponent from "@/components/StudyGood.vue";
import SummaryComponent from "@/components/Summary.vue";
import CautionComponent from "@/components/Caution.vue";

import { Switch as cSwitch } from "@coreui/vue";
import moment from "moment";
export default {
  name: "debtorView",
  components: {
    PaymentComponent,
    InvoiceComponent,
    LegalComponent,
    TaskJuryComponent,
    StudyGoodComponent,
    SummaryComponent,
    CautionComponent,
    cSwitch,
    DocumentComponent,
  },
  props: {
    caption: {
      type: String,
      default: "Deudor",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      user_id: JSON.parse(localStorage.getItem("auth"))[0].id,
      options: {
        // https://momentjs.com/docs/#/displaying/
        format: "DD/MM/YYYY h:mm A",
        useCurrent: true,
        showClear: true,
        showClose: true,
        minDate: moment().subtract(1, "d"),
        maxDate: moment(),
      },
      table: "debtors",
      lstDocument: [],
      lstProcess: [],
      lstType: [],
      lstPrivacy: [],

      lstTipificacion: [],
      tipificacion: null,
      tipoGestion: null,
      lstTipoAmbito: [],
      tipoAmbito: null,
      debtor: {},
      is_smaller_amount: null,
      pre_written: null,
      total_capital: 0,
      datos: [],
      errores: [],

      lstTaskManagements: [],
      lstTypeTaskManagement: [],
      task_management: {
        date: null,
        minutes: null,
        type: null,
        task_id: null,
        management: null,
        customer_id: null,
        debtor_id: null,
        user_id: null,
        status_id: null,
        privacy: 52, // PUBLICA
      },
      task_management_edit: {},
      settlement: {},
      status_debt: false,
      status_debt_count: 0,
      labelTxt: {
        dataOn: "Si",
        dataOff: "No",
      },
      currency: null,
      file: null,
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      VER_HONORARIOS: false,
      EDITAR_DEUDOR: false,
      CREAR_GESTIONES: false,
      ELIMINAR_GESTIONES: false,
      EDITAR_GESTIONES: false,
      EDITAR_TIPIFICACION: false,
      EDITAR_ETAPA: false,
      CERRAR_DEUDA: false,
    };
  },
  mounted() {
    this.initDebtor();
    console.log("Rol =>" + this.role_id);
  },
  computed: {},
  methods: {
    initDebtor() {
      showLoader();

      // PROCESOS
      this.$http.get(`${this.$urlApi}process?token=${this.token}`).then(
        (response) => {
          this.lstProcess = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // 14:  PRIVACIDAD
      this.$http.get(`${this.$urlApi}parameters/14?token=${this.token}`).then(
        (response) => {
          this.lstPrivacy = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // 16: TIPO DE GESTIONES - DEUDOR
      this.$http.get(`${this.$urlApi}parameters/16?token=${this.token}`).then(
        (response) => {
          this.lstTypeTaskManagement = response.data.data;
        },
        (error) => {
          console.log(error);
          hideLoader();
        }
      );

      // CARGAR EL DEUDOR SELECCIONADO
      let id = this.$route.params.id;
      this.$http
        .get(`${this.$urlApi}debtors/all/${id}?token=${this.token}`)
        .then(
          (response) => {
            this.debtor = response.data.data;
            console.log("Deudor -------------------------------------------------", response.data.data);
            this.validateDebtor(this.debtor.staff_user_id);
            this.getTypes(this.debtor.process_id);
            this.getTaskManagement();
            this.getSmallerAmount(this.debtor.id);
            this.getPreWritten(this.debtor.id);
            this.getSettlementByDebtor(this.debtor.id);
            this.enabledActions();
          },
          (error) => {
            this.errores = getMsgError(error);
          }
        );

      // DIVISA ASIGNADA EL DEUDOR
      this.$http
        .get(`${this.$urlApi}currencies/debtor/${id}?token=${this.token}`)
        .then(
          (response) => {
            console.log(
              "currency -------------------------------------->",
              response
            );
            this.currency = response.data.currency;
          },
          (error) => {
            console.log(error);
          }
        );

      hideLoader();
    },

    validateDebtor(staff_user_id){
      if(this.role_id == 4 && this.user_id != staff_user_id){
        location.href = `${location.origin}/#/404`;
      }
    },
    getTypes(process) {
      // DETERMINAR SI ESTA EN PROCESO PREJURIDICO O JURIDICO PARA LISTAR LA TIPIFICACIÓN QUE LE CORRESPONDE
      // 1: Prejurídico
      // 2: Jurídico
      let tp_parameter = 0;

      if (process == 1) tp_parameter = 15;
      if (process != 1) tp_parameter = 20;
      // debugger;

      // TIPIFICACIÓN
      this.$http
        .get(`${this.$urlApi}parameters/${tp_parameter}?token=${this.token}`)
        .then(
          (response) => {
            response.data.data.forEach((item) => {
              item.disabled = false;

              // 55: Castigado
              // 56: Devuelto (Otros)
              // 57: Enviar a demanda
              // 64: Suspendido
              // 81: Devuelto por reorganización
              // 82: Devuelto por liquidación
              // 83: Solicitud de suspensión
              if (
                item.id == 55 ||
                item.id == 56 ||
                item.id == 57 ||
                item.id == 64 ||
                item.id == 81 ||
                item.id == 82
              ) {
                item.disabled = this.role_id == 1 ? false : true;
              }

              // if (item.id == 64 && this.role_id == 4) item.disabled = false;

              this.lstType.push(item);
            });

            // this.lstType = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        );


        if(process == 2) {

          this.$http.get(`${this.$urlApi}parameters/15?token=${this.token}`).then(
            (response) => {
              response.data.data.forEach((item) => {

                // 54: Acuerdo de pago
                // 62: Recomendación de castigo (Correo Vanessa)
                // 64: Suspendido
                // 66: Ya pago
                // 80: Solicitud de devolución
                // 81: Devuelto por reorganización

                if (
                  item.id == 54 ||
                  item.id == 62 ||
                  item.id == 64 ||
                  item.id == 66 ||
                  item.id == 80 ||
                  item.id == 81
                ) {
                  this.lstType.push(item);
                }
              });
            },
            (error) => {
              console.log(error);
            }
          );

        }
    },

    editStaf() {
      showLoader();
      let id = this.customer.id;
      this.datos = JSON.stringify(this.customer);

      this.$http
        .put(`${this.$urlApi}debtors/${id}?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          // console.log(response)
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Registro actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              location.href = `${location.origin}/#/debtors`;
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    editDebtor() {
      let id = this.$route.params.id;
      this.$router.push({ path: `../../debtors/edit/${id.toString()}` });
    },
    addFile(f) {
      //   this.getDocuments()
    },
    getTaskManagement: function (urlPage) {
      showLoader();
      let id = this.$route.params.id;
      // DETERMINAR EL NUMERO DE LA PAGINA
      let page = darNumeroPaginaPaginacion(urlPage);

      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);

      var user_id = auth[0].id;

      // ARMAR LA URL CON LA PAGINACIÓN
      let url = `${this.$urlApi}taskmanagements/debtor/${id}/user/${user_id}?token=${this.token}&page=${page}`;

      this.$http
        .get(url, this.auth, {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            this.lstTaskManagements = response.data.data.data;
            this.paginationGestion = setPaginator(response.data.data);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    validarTiempoDiarioGestiones(task_management) {
      if (task_management.date !== null && task_management.minutes !== null) {
        let auth = localStorage.getItem("auth");
        auth = JSON.parse(auth);

        var dateString = task_management.date.toString();
        var momentObj = moment(dateString, "DD/MM/YYYY h:mm A");
        var momentString = momentObj.format("YYYY-MM-DD");

        this.$http
          .get(
            `${this.$urlApi}taskmanagements/minutes/${auth[0].id}/${momentString}?token=${this.token}`
          )
          .then(
            (response) => {
              console.log(
                "Total minutos hoy => " + response.data.data.total_minutos
              );
              let totalMinutos =
                parseInt(response.data.data.total_minutos) +
                parseInt(task_management.minutes);

              if (totalMinutos > this.$maxMinutes) {
                this.$swal({
                  title: "Advertencia",
                  text: "Ya superó su cuota laboral del día! =>" + momentString,
                  type: "warning",
                  showCancelButton: false,
                  confirmButtonText: "Aceptar",
                });

                task_management.minutes = null;
                return false;
              }
            },
            (error) => {
              console.log(error);
            } 
          );
      }
    },
    saveTaskManagement() {
      showLoader();
      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.task_management.debtor_id = this.debtor.id;
      this.task_management.user_id = auth[0].id;
      this.datos = JSON.stringify(this.task_management);

      let formData = new FormData();
      formData.append("data", this.datos);
      formData.append("document", this.file);

      this.$http
        .post(
          `${this.$urlApi}taskmanagements/storewithfile?token=${this.token}`,
          formData,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          // console.log(response)

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Gestión guardada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.task_management = {
                date: null,
                minutes: null,
                type: null,
                task_id: null,
                management: null,
                customer_id: null,
                debtor_id: null,
                user_id: null,
                status_id: null,
                privacy: null,
              };

              this.getTaskManagement();
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    deleteTaskManagement(task_management) {
      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE ELIMINAR
      if (!this.isAdmin) {
        var auth = localStorage.getItem("auth");
        auth = JSON.parse(auth);
        var user_id = auth[0].id;

        if (task_management.user_id != user_id) {
          this.$swal({
            title: "Advertencia",
            text:
              "La gestión no se puede eliminar, fue creada por otro usuario!",
            type: "warning",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }

        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(
          task_management._created_at,
          "YYYY-MM-DD HH:mm:ss"
        );
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "La gestión ya superó los 10 minutos para ser eliminada, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar la gestión ?",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(
              `${this.$urlApi}taskmanagements/${task_management.id}?token=${this.token}`,
              { headers: { "Content-Type": "application/json" } }
            )
            .then(function (response) {
              //console.log(response)
              hideLoader();

              this.$swal({
                title: "Buen trabajo",
                text: "Gestión eliminada correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getTaskManagement();
                }
              });
            })
            .catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    editTaskManagement(task_management) {
      // VALIDAR SI ES UN COMERCIAL Y SI PUEDE EDITAR
      if (!this.isAdmin) {
        // VERIFICAR EL TIEMPO TRANSCURRIDO
        var fechaGestion = moment(
          task_management._created_at,
          "YYYY-MM-DD HH:mm:ss"
        );
        var fechaActual = moment(new Date(), "YYYY-MM-DD HH:mm:ss");
        var dias = fechaActual.diff(fechaGestion, "days");
        var minutos = fechaActual.diff(fechaGestion, "m");

        if (dias > 0 || minutos > 10) {
          this.$swal({
            title: "Oops...",
            text:
              "La gestión ya superó los 10 minutos para ser editada, contacte con el administrador.",
            type: "error",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
          return false;
        }
      }

      this.errores = [];
      $("#dlgTaskManagement").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.task_management_edit = task_management;
      $("#dlgTaskManagement").modal("show");
    },
    updateTaskManagement() {
      showLoader();
      this.task_management_edit.debtor_id = this.debtor.id;
      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.task_management_edit.user_id = auth[0].id;
      this.datos = JSON.stringify(this.task_management_edit);

      let formData = new FormData();
      formData.append("data", this.datos);
      formData.append("document", this.file);
      formData.append("_method", "PUT");

      this.$http
        .post(
          `${this.$urlApi}taskmanagements/updatewithfile/${this.task_management_edit.id}?token=${this.token}`,
          formData,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          //console.log(response)
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Gestión actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.task_management_edit = {};

              this.lstTaskEditAux = [];
              this.getTaskManagement();
              $("#dlgTaskManagement").modal("hide");
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    closeTaskManagement() {
      this.task_management_edit = {
        date: null,
        minutes: null,
        type: null,
        task_id: null,
        management: null,
        customer_id: null,
        user_id: null,
        status_id: null,
      };
      $("#dlgTaskManagement").modal("hide");
    },

    getSmallerAmount(debtor_id) {
      this.$http
        .get(
          `${this.$urlApi}invoices/smaller_amount/${debtor_id}?token=${this.token}`
        )
        .then(
          (response) => {
            // console.log(response.data)
            this.is_smaller_amount = response.data.is_smaller_amount;
            this.total_capital = response.data.total_capital;
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getPreWritten(debtor_id) {
      // debtor_id = 100
      this.$http
        .get(
          `${this.$urlApi}invoices/pre_written/${debtor_id}?token=${this.token}`
        )
        .then(
          (response) => {
            // console.log(response.data)
            this.pre_written = response.data.pre_written;
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },

    visible(item /*, name = ""*/) {
      // console.log(name);
      // console.log(item);
      if (item == undefined) return false;
      else if (item == null) return false;
      else if (item == null) return false;
      else if (Array.isArray(item) && item.length == 0) return false;
      else return true;

      // return item != undefined && item != null && (item.length > 0 || item) ? true: false;
    },
    formatPrice(value) {
      let val = 0;

      // if(Number(value) > 999999999) val = (value / 1).toFixed(0).replace(".", ",");
      // else val = (value / 1).toFixed(2).replace(".", ",");

      val = (value / 1).toFixed(0).replace(".", ",");

      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getSettlementByDebtor(debtor_id) {
      // if (this.debtor.type == 66) {

      this.$http
        .get(
          `${this.$urlApi}settlements/debtor/${debtor_id}?token=${this.token}`
        )
        .then(
          (response) => {
            // BUSCAR
            if (response.data.success == false) {
              this.status_debt = false;
              this.$http
                .get(
                  `${this.$urlApi}debtors/settlement/${debtor_id}?token=${this.token}`
                )
                .then(
                  (response) => {
                    // console.log(response.data);
                    this.settlement = response.data.data;
                    if (this.role_id == 6) {
                      this.settlement.fee = 0;
                      this.settlement.fees_recovered = 0;
                    }
                  },
                  (error) => {
                    console.log(error);
                    hideLoader();
                  }
                );
            } else {
              this.status_debt = true;
              this.settlement = response.data.data;
              if (this.role_id == 6) {
                this.settlement.fee = 0;
                this.settlement.fees_recovered = 0;
              }
            }
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
      // } else {
      //   this.$http
      //     .get(
      //       `${this.$urlApi}debtors/settlement/${debtor_id}?token=${this.token}`
      //     )
      //     .then(
      //       response => {
      //         // console.log(response.data);
      //         this.settlement = response.data.data;
      //         if (this.role_id == 6) {
      //           this.settlement.fee = 0;
      //           this.settlement.fees_recovered = 0;
      //         }
      //       },
      //       error => {
      //         console.log(error);
      //         hideLoader();
      //       }
      //     );
      // }
    },
    actionDebt() {
      console.log("status_debt_count: " + this.status_debt_count);
      if (this.status_debt_count > 0) {
        if (this.status_debt) this.closeDebt();
        else if (!this.status_debt) this.openDebt();
      }
      this.status_debt_count += 1;
    },
    openDebt() {
      this.$swal({
        title: "Abrir la deuda",
        text:
          "¿Desea abiri la deuda ? ¡Este proceso es liquida nuevamente, hasta la fecha toda la deuda!",
        type: "question",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http
            .delete(
              `${this.$urlApi}settlements/debtor/${this.debtor.id}?token=${this.token}`
            )
            .then(function (response) {
              this.getSettlementByDebtor(this.debtor.id);
              hideLoader();
              this.$swal({
                title: "Buen trabajo",
                text: "Deuda abierta correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              });
            })
            .catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    closeDebt() {
      if (this.status_debt) {
        this.$swal({
          title: "Cerrar la deuda",
          text: "¿Desea cerrar la deuda ? ¡Este proceso es irreversible!",
          type: "question",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Aceptar",
        }).then((result) => {
          if (result.value) {
            let auth = localStorage.getItem("auth");
            auth = JSON.parse(auth);
            this.settlement.debtor_id = this.debtor.id;
            this.settlement.user_id = auth[0].id;
            this.settlement.date = moment(String(new Date())).format(
              "YYYY-MM-DD"
            );

            var por_recuperar =
              this.settlement.capital -
              this.settlement.initial_payments +
              this.settlement.interest +
              this.settlement.fee;

            var falta_recuperar =
              this.settlement.capital -
              this.settlement.initial_payments +
              this.settlement.interest +
              this.settlement.fee -
              (this.settlement.capital_recovered +
                this.settlement.interests_recovered +
                this.settlement.fees_recovered);

            this.settlement.discount = 0;

            // CALCULAR EL PROCENTAJE DE DESCUENTO AL CERRAR LA DEUDA
            if(falta_recuperar > 0 && por_recuperar > 0)
            {
              this.settlement.discount = roundToTwo(
                (falta_recuperar * 100) / por_recuperar
              );
            }

            let datos = JSON.stringify(this.settlement);

            // console.log(this.settlement); return;

            showLoader();
            this.$http
              .post(`${this.$urlApi}settlements?token=${this.token}`, datos, {
                headers: { "Content-Type": "application/json" },
              })
              .then(function (response) {
                this.getSettlementByDebtor(this.debtor.id);
                // console.log(response.data);

                hideLoader();

                this.$swal({
                  title: "Buen trabajo",
                  text: "Deuda cerrada correctamente!",
                  type: "success",
                  showCancelButton: false,
                  confirmButtonText: "Aceptar",
                });
              })
              .catch((error) => {
                console.log(error);
                hideLoader();
              });
          }
        });
      }
    },

    closeDebtType() {
      let auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      this.settlement.debtor_id = this.debtor.id;
      this.settlement.user_id = auth[0].id;
      this.settlement.date = moment(String(new Date())).format("YYYY-MM-DD");

      var por_recuperar =
        this.settlement.capital -
        this.settlement.initial_payments +
        this.settlement.interest +
        this.settlement.fee;

      var falta_recuperar =
        this.settlement.capital -
        this.settlement.initial_payments +
        this.settlement.interest +
        this.settlement.fee -
        (this.settlement.capital_recovered +
          this.settlement.interests_recovered +
          this.settlement.fees_recovered);

      // CALCULAR EL PROCENTAJE DE DESCUENTO AL CERRAR LA DEUDA
      this.settlement.discount = roundToTwo(
        (falta_recuperar * 100) / por_recuperar
      );

      let datos = JSON.stringify(this.settlement);

      showLoader();
      this.$http
        .post(`${this.$urlApi}settlements?token=${this.token}`, datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          this.getSettlementByDebtor(this.debtor.id);
          // console.log(response.data);

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Deuda cerrada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          });
        })
        .catch((error) => {
          console.log(error);
          hideLoader();
        });
    },

    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth);
      // console.log('auth --------------------------------------------------------------------------->', auth);
      switch (this.role_id) {
        case "1": // ADIMISTRADOR
          this.EDITAR_DEUDOR = true;
          this.CREAR_GESTIONES = true;
          this.ELIMINAR_GESTIONES = true;
          this.EDITAR_GESTIONES = true;
          this.EDITAR_TIPIFICACION = true;
          this.EDITAR_ETAPA = true;
          this.VER_HONORARIOS = true;
          this.CERRAR_DEUDA = true;
          break;

        case "2": // COMERCIAL
        case "7": // GERENTE COMERCIAL
          this.EDITAR_DEUDOR = true;
          this.CREAR_GESTIONES = false;
          this.ELIMINAR_GESTIONES = false;
          this.EDITAR_GESTIONES = false;
          this.EDITAR_TIPIFICACION = false;
          this.EDITAR_ETAPA = false;
          this.VER_HONORARIOS = true;
          this.CERRAR_DEUDA = true;
          break;

        case "4": // PREJURIDICO
          this.EDITAR_DEUDOR = true;
          this.CREAR_GESTIONES = true;
          this.ELIMINAR_GESTIONES = true;
          this.EDITAR_GESTIONES = true;
          this.EDITAR_TIPIFICACION = true;
          this.EDITAR_ETAPA = false;
          this.VER_HONORARIOS = false;
          this.CERRAR_DEUDA = false;
          break;

        case "8": // GERENTE PREJURIDICO
          this.EDITAR_DEUDOR = true;
          this.CREAR_GESTIONES = true;
          this.ELIMINAR_GESTIONES = true;
          this.EDITAR_GESTIONES = true;
          this.EDITAR_TIPIFICACION = true;
          this.EDITAR_ETAPA = false;
          this.VER_HONORARIOS = false;
          this.CERRAR_DEUDA = true;
          break;

        case "5": // JURIDICO
        case "9": // GERENTE JURIDICO
          this.EDITAR_DEUDOR = true;
          this.CREAR_GESTIONES = true;
          this.ELIMINAR_GESTIONES = true;
          this.EDITAR_GESTIONES = true;
          this.EDITAR_TIPIFICACION = true;
          this.EDITAR_ETAPA = false;
          this.VER_HONORARIOS = false;
          this.CERRAR_DEUDA = true;
          break;

        default:
          this.EDITAR_DEUDOR = false;
          this.CREAR_GESTIONES = false;
          this.ELIMINAR_GESTIONES = false;
          this.EDITAR_GESTIONES = false;
          this.EDITAR_TIPIFICACION = false;
          this.EDITAR_ETAPA = false;
          this.VER_HONORARIOS = false;
          this.CERRAR_DEUDA = false;
          break;
      }

      // VALIDACIÓN DE ESTADOS
      // C: Castigado
      // D: Devuelto
      // P: Pausado
      this.CREAR_GESTIONES =
        this.debtor.status == "C" ||
        this.debtor.status == "D" ||
        this.debtor.status == "P"
          ? false
          : this.CREAR_GESTIONES;

      this.ELIMINAR_GESTIONES =
        this.debtor.status == "C" ||
        this.debtor.status == "D" ||
        this.debtor.status == "P"
          ? false
          : this.ELIMINAR_GESTIONES;

      this.EDITAR_GESTIONES =
        this.debtor.status == "C" ||
        this.debtor.status == "D" ||
        this.debtor.status == "P"
          ? false
          : this.EDITAR_GESTIONES;
    },

    changeType() {
      showLoader();
      let id = this.debtor.id;
      this.debtor.user_id = this.user_id;
      this.debtor.customer_business_name = this.debtor.customer.business_name;
      this.debtor.url = `${location.origin}/#/debtors/view/${id}`;
      this.datos = JSON.stringify(this.debtor);
      // console.log(this.debtor);
      // return;

      this.$http
        .put(
          `${this.$urlApi}debtors/changetype/${id}?token=${this.token}`,
          this.datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          // console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Tipificación actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              hideLoader();
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    changeProcess() {
      // console.log(this.debtor.staff_customers_id);
      // return;

      showLoader();
      let id = this.debtor.id;

      this.datos = JSON.stringify(this.debtor);

      this.$http
        .put(
          `${this.$urlApi}debtors/changeprocess/${id}?token=${this.token}`,
          this.datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          //console.log(response)
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Etapa actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              hideLoader();
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    changeProbability() {
      showLoader();
      let id = this.debtor.id;

      this.datos = JSON.stringify(this.debtor);

      this.$http
        .put(
          `${this.$urlApi}debtors/changeprobability/${id}?token=${this.token}`,
          this.datos,
          { headers: { "Content-Type": "application/json" } }
        )
        .then(function (response) {
          console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Probabilidad actualizada correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              hideLoader();
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    formatDateDescription(value) {
      if (!value) return "";
      else {
        if (value == "--") return value;
        else {
          var d = moment(value).format("DD");
          var m = moment(value).format("MMM");
          var a = moment(value).format("YYYY");
          return d + " de " + m + " " + a;
        }
      }
    },
    // ---------------------------------------------
    onFileChange(e) {
      console.log(e.target.files[0]);
      this.file = e.target.files[0];
    },
    dowloadDocument(doc) {
      window.open(`${this.$urlApi}file/${doc.name}?token=${this.token}`);
    },
  },
};
</script>
